import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class EditEntityCompanySearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {companySearch: (this.props.companySearch !== null) && (this.props.companySearch !== undefined) ? this.props.companySearch : false};

        this.changeFlag = this.changeFlag.bind(this);

        this.blurAction = this.blurAction.bind(this);
    }

    changeFlag(event) {
        let newVal = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        this.setState({
            companySearch: newVal
        }, this.blurAction);
    }

    blurAction() {
        if (this.props.companySearch !== this.state.companySearch) {
            this.props.onBlur("companySearch", this.state.companySearch);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companySearch !== this.props.companySearch) {
            this.setState({companySearch: nextProps.companySearch})
        }
    }


    render() {
        return (
            <div className="edit-third-party__about__input-group">
                <input type="checkbox"
                       id="edit-third-party__about__companySearch"
                       name="companySearch"
                       checked={this.state.companySearch}
                       onChange={this.changeFlag} />
                <div className="row-label">
                    <label className="row-label" htmlFor="edit-third-party__about__companySearch">
                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.companySearchLabel" />
                    </label>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditEntityCompanySearch.jsx